//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from 'react';
import context from 'context/context';
import { useHistory, useLocation } from 'react-router-dom';
import * as moment from 'moment';
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import { CSVLink } from 'react-csv';
import { exportHeaders } from './export';
import InputAdornment from "@material-ui/core/InputAdornment";

// custom pages
import Table from 'components/Table/Table';
import milestonepromotion from 'apis/milestonePromotion/milestonepromotion';
import { styles } from '../Promotion/Criteria/styles';
import Loader from 'components/Loader/Loader';
import VisibilityIcon from '@material-ui/icons/Visibility';
import useDebounce from "helpers/useDebounce";

//access
import access from 'config/access';

// material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import TextField from "@material-ui/core/TextField";
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Box from '@material-ui/core/Box';

// material-ui icons
import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { withStyles } from "@material-ui/core/styles";
import searchIcon from "assets/img/Search_Icon.png";

//Helpers
import { dateFormat } from "helpers/dataFormat";
const CssTextField = withStyles({
  root: {
      '& label.Mui-focused': {
          color: '##D3D3D3',
      },
      '& .MuiFormLabel-root': {
          color: '#707070',
      },
      '& .MuiInputBase-input': {
          color: '#707070',
      },
      '& .MuiInput-underline:before': {
          borderBottomColor: '#707070!important',
      },
      '& .MuiInput-underline:after': {
          borderBottomColor: '#707070!important',
      },
      '& .MuiOutlinedInput-root': {
          '& fieldset': {
              borderColor: '#707070',
          },
          '&:hover fieldset': {
              borderColor: '#707070',
          },
          '&.Mui-focused fieldset': {
              borderColor: '#707070',
          },
          '&.MuiOutlinedInput-root': {
              borderRadius: 20,
          },
          '&.MuiOutlinedInput-root': {
              marginTop: 0,
              borderRadius: 20,
              background: '#ededed',
              marginTop: -11,
              display : 'flex',
              marginLeft :30,
              marginRight:10
          },
      },
  },
})(TextField);


export default function MilestonePromotion(props) {
  const { state, dispatch } = useContext(context);
  const { getmilestoneCriteria, exportAPI, searchcriteriaAPI} = milestonepromotion();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  const [data, setData] = useState([]);
  const [promotionData, setPromotionData] = useState({});
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  const { t, i18n } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [exportData, setExportData] = useState([])
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [value, setValue] = React.useState(0);



  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: 'SET_PATHNAME',
      payload: ['HOME', 'ADMIN', 'Promotion Management', 'Criteria'],
    });
   
  }, []);

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  useEffect(() => {
    if (location?.state?.data) {
      setPromotionData(location?.state?.data);
    }
  });

  // handling api calls
  useEffect(() => {
    if (location?.state?.id) {
      handleGet();
    }
  }, [offset]);

  // get api func
  const handleGet = async () => {
    try {
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
        // promotionId: location?.state?.id,
      };
      let res = await getmilestoneCriteria(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  async function handleExport() {
    try {
      setLoading(true)
      let values = {
        searchValue: searchValue,
        promotionId: location?.state?.id,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await exportAPI(values);
      if (res) {
   
        setExportData(res.data.map(obj => {
          return {
            ...obj,
            category_value: obj?.category_value + String.fromCharCode(8203),
          }
        }));
        setLoading(false)
        dispatch({ type: "SET_LOADING", payload: false });
        return true
      }
      setLoading(false)
      return false
    }
    catch (err) {
      console.log({ err });
      setLoading(false)

      return false
    }
  }

  async function handleSearch() {
    try {
      // setLoading(true);
      let values;
      values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,

       
        
      };
     
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchcriteriaAPI(values);
      dispatch({ type: "SET_LOADING", payload: false });
      
      if (res) {
        setData(res.data);
        setCount(res.count);
        return;
        // setLoading(false);
       
      }
      setData([]);
    }
    catch (e) {
      console.log({ e });
    }
  }

  useEffect(() => {
    searchValue && searchValue.length > 0 ? handleSearch() : handleGet();
  }, [offset]);

  // // handling search api
  useEffect(() => {
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else {
      setOffset(1);
    }
  }, [searchBounceValues])

  const categoryLabels = {
    "product_primary_class_id": "MPC",
    "product_brand_name_code": "Brand",
    "product_code": "Product",
    "business_unit_code": "GL Cost Center",
    "label_class_code": "Label Class Code",
    "loyalty_category_code": "Sales Category",
    "order_source_code": "Order Source Code",
    "primary_major_class_code": "Primary Major Class Code",
    "primary_submajor_class_code": "Primary Submajor Class Code",
    "primary_minor_class_code": "Primary Minor Class Code",
    "loyalty_id": "Loyalty ID",
    "order_promotion_code": "Order Promotion Code",
    "order_level_coupon":"Order Level Coupon",
    "line_promo_coupon":"Line Promo Coupon",
    "promotion": "Promotion",
    "equipment_order_number":"Equipment Order Number"



  };

  

  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        <Grid xs={12} sm={6} lg={6} >

          {/* <span style={{ fontSize: 18 }}>
            <strong>{t('Criteria')}</strong>
          </span> */}
         
          {/* {promotionData?.is_active && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={() => {
                if (state?.userInfo?.editAction) {

                  history.push('/dashboard/upload-criteria', {
                    id: location?.state?.id,
                  });
                  return;
                } else {
                  toast.error(state.userInfo?.editAccess)
                  return;
                }
              }}
            >
              {t('Upload')}
            </Button>
          )} */}
          
          
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={() =>history.push('/dashboard/create-milestone-criteria')    
              }
            >
              
              {t('Create')}
            </Button>
          
           


        </Grid>
        <Grid xs={12} sm={6} lg={6} style={{ textAlign: 'end', paddingTop: '10px' }}>
        
        <CssTextField
            placeholder="Search for Category Value"
            type={"text"}
            variant="outlined"
            // onKeyDown={blockInvalidCharForText}
            className={classes.searchInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchValue.length > 0 ? (
                    <CloseOutlinedIcon
                      className={classes.searchInputIcon}
                      onClick={() => {
                        setSearchValue("");
                        setOffset(1);
                        handleGet();
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt=""
                      width="20px"
                      className={classes.searchInputIcon}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setOffset(1);
              if (e.target.value.length == 0) {
                handleGet();
              }
            }}
            onClick={() => {
              setOffset(offset);
            }}
          />
          <CSVLink
            id="csv"
            data={exportData.map(item => ({
              ...item,
              category:  categoryLabels[item.category],
              is_active : item.is_active ? "Active" :"Inactive"

            }))}


            headers={exportHeaders.map((head) => head)}
            filename={
              `Thrive_Unlocked_Criteria_` + moment(new Date()).format("MM-DD-YYYY,h:mm A") + ".csv"
            }
            className={classes.CSVlink}
          />
          <button
            disabled={loading}
            className={classes.exportBtn}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {loading ? (
              <div class="snippet" style={{ marginLeft: 55 }}>
                <div class="stage">
                  <div class="dot-typing-e"></div>
                </div>
              </div>
            ) :
              `Export`
            }
          </button>
        </Grid>
      </Grid>
{/* 
      <Grid container className={classes.promotionDetails}>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Promotion Id')}</strong> : {promotionData?.promotion_id}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Promotion Name')}</strong> : {promotionData?.promotion_name}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Promotion Description')}</strong> :{' '}
          {promotionData?.promotion_description}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Start Date')}</strong> :{' '}
          {promotionData?.start_date
            ? dateFormat(promotionData?.start_date, i18n.language)
            : '-'}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('End Date')}</strong> :{' '}
          {promotionData?.end_date
            ? dateFormat(promotionData?.end_date, i18n.language)
            : '-'}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Expired')}</strong> :{' '}
          {promotionData?.expired ? (
            <span style={{ color: 'red' }}>{t("Yes")}</span>
          ) : (
            <span style={{ color: 'green' }}>{t("No")}</span>
          )}
        </Grid> */}
        {/* <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Ranking')}</strong> : {promotionData?.ranking}
        </Grid> */}
        {/* <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Type')}</strong> : {promotionData?.type}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t('Frequency')}</strong> : {t(promotionData?.frequency)}
        </Grid>
      </Grid> */}
      <Grid className={classes.tableDownInResponsive}>
        <Grid xs={12} sm={12} lg={12}>
          {res ? (
            <Table
              headings={[
                'S.No',
                'Category',
                'Category Value',
                'Type',
                'Status',
                'Created',
                'View',
              ]}
              data={
                data &&
                data.map((d, i) => [
                  (offset - 1) * 10 + i + 1,
                  categoryLabels[d?.category],
                  d?.category_value,
                  d?.type,
                  d?.is_active ? (
                    <span style={{ color: 'green' }}>{t("Active")}</span>
                  ) : (
                    <span style={{ color: 'red' }}>{t("Inactive")}</span>
                  ),
                  d?.created_at ? dateFormat(d?.created_at, i18n.language) : '-',
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      history.push('/dashboard/view-milestone-criteria', { data: d });
                    }}
                  >
                    <VisibilityIcon />
                  </div>
                  ,
                ])
              }
              offset={offset}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
            />
          ) : (
            <Loader Loading={true} top={'15%'} />
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}